import {ALLOWED_FIELDS} from '@components/templated-message/templated-message.consts';

export const trimSpaces = (value: string): string => {
  const res = value.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
  return res.replace(/&nbsp;/g, '');
};

export const getFieldHtml = (
  id: string | number,
  fieldName: ALLOWED_FIELDS,
  getFieldValue: (field: ALLOWED_FIELDS) => string
) => {
  return `<b id="${id}" data-field="${fieldName}">${getFieldValue(
    fieldName as ALLOWED_FIELDS
  )}</b>`;
};

export const templateToHtml = (
  template: string,
  getFieldValue: (field: ALLOWED_FIELDS) => string
): string => {
  if (!template) {
    return '';
  }

  let htmlValue = template;

  const matches = [...htmlValue.matchAll(/{{([a-zA-Z]+)}}/g)];
  matches.forEach(([pattern, fieldName], index) => {
    htmlValue = htmlValue.replace(
      pattern,
      getFieldHtml(index, fieldName as ALLOWED_FIELDS, getFieldValue)
    );
  });

  return htmlValue;
};

export const htmlToTemplate = (newHtmlValue = ''): string => {
  if (!newHtmlValue) {
    return '';
  }
  let template = newHtmlValue;
  const matches = [
    ...template.matchAll(
      /<b id="[\d]+" data-field="([a-zA-Z]+)">[$.,%\-:();a-zA-Z[\]\s0-9]+<\/b>/g
    ),
  ];
  matches.forEach(([pattern, fieldName]) => {
    template = template.replace(pattern, `{{${fieldName}}}`);
  });
  template = template.replace(/&nbsp;/g, ' ');
  template = template.replace(/<br>/g, '\n');
  template = template.trim();

  return template;
};
